// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
export const createStorePoCallConsent = (client) => ({
    /**
     * `POST /store/po-call-consent/withdraw`
     *
     * @operationId StorePoCallConsentWithdrawCreate
     * @source apps/backend/src/api/store/po-call-consent/withdraw/route.ts
     */
    updateWithdraw: (body, query, headers) => client.fetch("/store/po-call-consent/withdraw", { method: "POST", body, query, headers }),
});
//# sourceMappingURL=po-call-consent.js.map